import Vue from "vue";
import App from "./App.vue";
import dataV from "@jiaminghi/data-view";
import "./assets/styles/element-variables.scss";

import "@/assets/styles/index.scss"; // global css
import "@/assets/styles/ruoyi.scss"; // ruoyi css
import ElementUI from "element-ui";
import "./assets/styles/element-variables.scss";
import axios from "axios";
import store from "./store";
import router from "./router/index.js";
import "./permission"; // permission control
// axios.defaults.baseURL = 'http://192.168.1.197:8880'
axios.defaults.baseURL = "http://grove.cpzsyun.com:81/api";
// axios.interceptors.request.use(config=>{
//   config.headers.token = window.sessionStorage.getItem('token');
//   return config
// })
Vue.use(ElementUI);
Vue.prototype.$https = axios;
Vue.use(dataV);
Vue.config.productionTip = false;

new Vue({
  store,
  render: (h) => h(App),
  router,
}).$mount("#app");
